import React from "react";
import { observer } from "mobx-react";
import Actions from "./Actions";

const Card = observer((props) => {
    

  return (
    <>
        <div className="card mb-4 card-action">
            <div className="card-header align-items-center">
                <h5 className="card-action-title mb-0 text-primary">{props.title}</h5>

                {props.actions && props.actions.length ? (<Actions actions={props.actions} />) : (<></>)}
              
            </div>
            <div className="card-body">
                {props.children}              
            </div>
          </div>
            
    </>
  );
});

export default Card;

